import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningPatagonia.css';

const DiningPatagonia: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'restaurant',
      image: images.patagoniaRestaurant || images.restaurantFeature,
      title: 'Our Restaurant',
      content: 'Our restaurant, for the exclusive use of Awasi guests, offers a daily menu using the finest local ingredients, adapted to your requirements. We are proud to deliver levels of culinary excellence that define us as members of Relais & Châteaux.'
    },
    {
      id: 'cuisine',
      image: images.patagoniaDining2 || images.foodImage,
      title: 'Fresh fish from the South Pacific fjords',
      content: 'Fish caught in the fjords of the South Pacific, southern king crab, locally reared lamb, and freshly harvested vegetables and native berries. At Awasi Patagonia, guests enjoy authentic regional produce presented in creative, refined dishes.'
    },
    {
      id: 'chef',
      image: images.chefMarcoSalinas || images.teamMember2,
      title: 'Marco Salinas - Head Chef',
      content: 'Marco Salinas is the Chef of Awasi Patagonia. Growing up in Santiago de Chile, Marco was inspired by his grandmother\'s Spanish and Mediterranean cuisine. Now in Patagonia, he highlights the region\'s local produce, focusing on lamb, king crab, deep-sea fish and the unique calafate berry.'
    },
    {
      id: 'ingredients',
      image: images.patagoniaDining3 || images.foodImage,
      title: 'Seasonal produce, local flavours',
      content: 'Our menu celebrates the bounty of Patagonia with seasonal ingredients and local flavours, based on our guests\' preferences. Each dish reflects the changing seasons and the beauty of the surrounding landscape.'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="patagonia" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => (
            <div key={panel.id} className="dining-panel">
              <div className="dining-panel__image">
                <img src={panel.image} alt={panel.title} />
              </div>
              <div className="dining-panel__content">
                <h2 className="dining-panel__title">{panel.title}</h2>
                <p className="dining-panel__text">{panel.content}</p>
                <button className="dining-panel__cta">CONTACT US</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="patagonia" />
    </div>
  );
};

export default DiningPatagonia;